@if (tracking) {
    <div class="tracking-container">
        <!-- Title -->
        @if (title) {
            <div class="title" [innerHTML]="title"></div>
        }
        <!-- Header text -->
        @if (headerText) {
            <div class="header" [innerHTML]="headerText"></div>
        }
        <!-- Header attributes -->
        @if (tracking.headerAttributes && tracking.headerAttributes.length !== 0) {
            <table class="attributes-container">
                @for (attribute of tracking.headerAttributes; track attribute.label) {
                    <tr class="attribute">
                        <td class="label">{{ attribute.label }}</td>
                        <td class="value">{{ attribute.value }}</td>
                    </tr>
                }
            </table>
        }
        <!-- étapes -->
        <div class="main-container">
            <div class="steps-container">
                @for (step of tracking.steps; track step.id) {
                    <app-tracking-step [trackingStep]="step" [width]="stepComponentWidth"></app-tracking-step>
                }
            </div>
        </div>

        <!-- Footer attributes -->
        @if (tracking.footerAttributes && tracking.footerAttributes.length !== 0) {
            <table class="attributes-container">
                @for (attribute of tracking.footerAttributes; track attribute.label) {
                    <tr class="attribute">
                        <td class="label">{{ attribute.label }}</td>
                        <td class="value">{{ attribute.value }}</td>
                    </tr>
                }
            </table>
        }
        <!-- Footer text -->
        @if (footerText) {
            <div class="footer" [innerHTML]="footerText"></div>
        }

        <div>
            <!-- Utilisé comme balise de bas de page -->
        </div>
    </div>
}

<ngx-spinner name="main-spinner" bdColor="rgba(0, 0, 0, 0.2)" color="rgba(0, 0, 0, 1)" [fullScreen]="true" type="timer" size="medium">
    <p>Loading...</p>
</ngx-spinner>
